<!-- TODO(UX): Stacking 2 modals is a bad UX experience. This should be revisited once UI is updated. -->
<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask" @click.stop>
      <div class="modal-wrapper">
        <div class="modal-confirm-container container-fluid">
          <div class="modal-confirm-body">
            <div class="row">
              <div class="col-12 payjoy-card-modal-header">
                <div class="text-center">
                  <img
                    :src="`${useAsset(
                      'img/merchant-console/payjoy-card/payjoy-card-modal-header.svg'
                    )}`"
                    alt="PayJoy Card Banner"
                  />
                </div>
                <div
                  class="payjoy-card-modal-close-btn"
                  @click="cancelHandler()"
                >
                  <i class="fa-solid fa-xmark"></i>
                </div>
              </div>
              <div class="col-12 p-4 p-lg-5">
                <div class="row payjoy-card-modal-body-header">
                  <div class="col-12 text-center">
                    <h5>{{ t("PAYJOY_CARD_MODAL_HEADER_TITLE") }}</h5>
                    <h5>{{ t("PAYJOY_CARD_MODAL_HEADER_SUB_TITLE", { creditLineLimit }) }}</h5>
                  </div>
                </div>
                <div class="row payjoy-card-model-body-content mt-5">
                  <div class="col-12 col-md-6 mb-2 mb-lg-4">
                    <div class="row justify-content-start">
                      <div class="col-2 align-content-center">
                        <img
                          :src="`${useAsset(
                            'img/merchant-console/payjoy-card/modal_calendar_icon.svg'
                          )}`"
                          alt="Icon"
                        />
                      </div>
                      <div class="col">
                        <p>
                          <strong>{{ t("PAYJOY_CARD_MODAL_WEEKLY_PAYMENTS_TITLE", { count: creditLineTermInWeeks }) }}</strong>
                          <br />
                          <span v-html="t('PAYJOY_CARD_MODAL_WEEKLY_PAYMENTS_TEXT')"></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-2 mb-lg-4">
                    <div class="row justify-content-start">
                      <div class="col-2 align-content-center">
                        <img
                          :src="`${useAsset(
                            'img/merchant-console/payjoy-card/modal_money_icon.svg'
                          )}`"
                          alt="Icon"
                        />
                      </div>
                      <div class="col">
                        <p>
                          <strong>{{ t("PAYJOY_CARD_MODAL_CREDIT_GROWTH_TITLE") }}</strong>
                          <br />
                          <span v-html="t('PAYJOY_CARD_MODAL_CREDIT_GROWTH_TEXT')"></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-2 mb-lg-4">
                    <div class="row justify-content-start">
                      <div class="col-2 align-content-center">
                        <img
                          :src="`${useAsset(
                            'img/merchant-console/payjoy-card/modal_credit_card_icon.svg'
                          )}`"
                          alt="Icon"
                        />
                      </div>
                      <div class="col">
                        <p>
                          <strong>{{ t("PAYJOY_CARD_MODAL_DAY_ONE_BENEFITS_TITLE") }}</strong>
                          <br />
                          <span v-html="t('PAYJOY_CARD_MODAL_DAY_ONE_BENEFITS_TEXT')"></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-2 mb-lg-4">
                    <div class="row justify-content-start">
                      <div class="col-2 align-content-center">
                        <img
                          :src="`${useAsset(
                            'img/merchant-console/payjoy-card/modal_trending_up_icon.svg'
                          )}`"
                          alt="Icon"
                        />
                      </div>
                      <div class="col">
                        <p>
                          <strong>{{ t("PAYJOY_CARD_MODAL_NO_COMMITMENT_TITLE") }}</strong>
                          <br />
                          <span v-html="t('PAYJOY_CARD_MODAL_NO_COMMITMENT_TEXT')"></span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import { useI18n } from "@/apps/merchant3/composables/useI18n";

defineProps({
  show: { type: Boolean, default: false },
  creditLineLimit: { type: String },
  creditLineTermInWeeks: { type: Number, default: 0 },
});

const emit = defineEmits(["closeModal"]);
const { t } = useI18n();

const cancelHandler = () => {
  emit("closeModal", true);
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-confirm-container {
  min-width: 600px;
  width: 800px;
  min-height: 256px;
  margin: 0 auto;
  background-color: $pj-color-white;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  @media screen and (max-width: 767px) {
    min-width: auto;
    width: 354px;
  }
}

.modal-confirm-body {
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: $pj-color-black;
}
.payjoy-card-modal-header {
  position: relative;
  background-color: $pj-color-harp;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.payjoy-card-modal-header img {
  width: 100%;
}
.payjoy-card-modal-body-header h5 {
  color: $pj-color-green;
}
.payjoy-card-modal-body-header h3 {
  color: $pj-color-green-peas;
}
.payjoy-card-model-body-content {
  color: $pj-color-black;
  font-size: 17px;
  font-weight: normal;
}
.payjoy-card-model-body-content p {
  color: $pj-color-black !important;
}
.payjoy-card-model-body-content p span {
  font-weight: normal;
}
.payjoy-card-model-body-content img {
  width: 100%;
}
.payjoy-card-modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 10;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.payjoy-card-modal-close-btn i {
  font-size: 35px;
  color: $pj-color-black;
}

.payjoy-card-modal-cta {
  color: $pj-color-green;
  font-weight: bold;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-confirm-container,
.modal-leave-to .modal-confirm-container {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
